import { useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider, useSelector } from "react-redux";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import Login from "views/auth/Login";

// Redux store
import { store } from "./store/store";

import Agents from "layouts/Agents";
import TeamLead from "layouts/TeamLead";
import { AuthProvider } from "./AuthContext";
import TeamLeadDetails from "components/TeamLead/TeamLeadDetails";
import History from "layouts/History";
const MainApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user && user.AccessToken && location.pathname === "/") {
      navigate("/admin/worker");
    }
  }, [user, navigate, location.pathname]);

  return (
    <Routes>
      <Route path="admin/*" element={<Admin />} />
      <Route path="team-lead/*" element={<TeamLead />} />
      <Route path="agent/*" element={<Agents />} />
      <Route path="auth/*" element={<Auth />} />
      <Route path="landing" element={<Landing />} />
      <Route path="profile" element={<Profile />} />
      {/* <Route path="/details" element={<TeamLeadDetails />} /> */}
      <Route path="history/*" element={<History />} />
      <Route path="/" element={<Login />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

ReactDOM.render(
  <Provider store={store}>
      <AuthProvider>
        <BrowserRouter>
          <MainApp />
          <ToastContainer />
        </BrowserRouter>
      </AuthProvider>
  </Provider>,
  document.getElementById("root")
);
